import { useChannelStore } from "@/stores/channel.store";
import { apolloClient } from "@/utils/apollo";
import { resetGraphqlClient } from "@/utils/urql";
import { ApolloError } from "@apollo/client/errors";

export function useCleanupCache() {
  const channelStore = useChannelStore();

  async function cleanupCache() {
    try {
      await Promise.all([apolloClient.resetStore(), resetGraphqlClient()]);
      await channelStore.refreshPermissions();
    } catch (error) {
      if (error instanceof ApolloError) {
        // Ignore
      } else {
        throw error;
      }
    }
  }

  return { cleanupCache };
}
